import { provideNgxMask } from 'ngx-mask';

import {
	type ApplicationConfig,
	InjectionToken,
	provideZoneChangeDetection,
	Signal
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { authDependencies } from '@dependencies/auth';
import {
	commonDependencies,
	GLOBAL_HTTP_CONFIG,
	themeDependencies,
	translationDependencies
} from '@dependencies/shared';
import { userDependencies } from '@dependencies/users';

import { AuthenticationService, WebsocketService } from '@shared/services';

import { routes } from '@neki-app/app.routes';
import { I18nService } from '@neki-app/shared/services/translations/i18n.service';

export const DS_LOCALE = new InjectionToken<Signal<string>>('DS_LOCALE');

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideNgxMask(),
		{
			provide: GLOBAL_HTTP_CONFIG,
			useValue: {
				withCredentials: true
			}
		},
		{
			provide: DS_LOCALE,
			useFactory: (i18n: I18nService) => i18n.lang,
			deps: [I18nService]
		},
		...commonDependencies,
		...themeDependencies,
		...translationDependencies,
		...userDependencies,
		...authDependencies,
		AuthenticationService,
		WebsocketService
	]
};
